<template>
  <StyledDiv marginTop="20px">
    <StyledText
      :fontSize="styled('fontSize-medium')"
      padding="200px 0"
      class="adjustPadding"
      >Coming Soon...
      <hr />
      Redirecting to the Home Page</StyledText
    >
    <Bottom />
  </StyledDiv>
</template>

<script>
import { StyledDiv, StyledText } from "./styled";
import StyleCompiler from "./styled/StyleCompiler";
import Bottom from "./components/Bottom";

export default {
  components: { StyledDiv, StyledText, Bottom },
  mounted() {
    window.scrollTo(0, 0);
    setTimeout(() => {
      this.$router.push({ path: "/" });
    }, 3000);
  },
  methods: {
    styled(e) {
      return StyleCompiler(e);
    }
  }
};
</script>

<style>
@media (max-width: 500px) {
  .adjustPadding {
    padding: 50px 0 200px 0;
  }
}
</style>
